import { arrow } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";

import Button from "../Button";
import { Variant } from "../Types";

export interface BaseDropdownOption {
  label: string;
  value: string;
}

interface BaseDropdownProps {
  label: string;
  children: React.ReactNode;
  open: boolean;
  align: "left" | "right";
  variant?: Variant;
  setOpen: (open: boolean) => void;
  large?: boolean;
  className?: string;
  disabled?: boolean;
}

const BaseDropdown = ({
  label,
  children,
  open,
  align,
  variant,
  setOpen,
  large = false,
  className,
  disabled,
}: BaseDropdownProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setOpen(false));

  return (
    <div className={cn("relative flex gap-x-1", className)} ref={ref}>
      <Button
        variant={variant}
        label={label}
        large={large}
        onClick={() => setOpen(!open)}
        icon={
          <div className={cn("w-2 h-2", open && "rotate-180")}>{arrow}</div>
        }
        justifyBetweenIcon
        disabled={disabled}
      />
      {open && (
        <div
          className={cn(
            "absolute flex flex-col text-right top-full mt-1 rounded whitespace-nowrap max-h-96 overflow-y-auto overflow-x-hidden z-30 text-white bg-panel-background shadow-button",
            align === "left" ? "left-0" : "right-0",
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default BaseDropdown;
